<div class="info-message" [ngClass]="type">
  <mat-icon [svgIcon]="icon"></mat-icon>&nbsp;{{ message }}
</div>
